import { css } from 'styled-components';
import { getTypography, FontWeight, TypographyName, BreakpointQueryName } from '../../theme';
export const main = _ref => {
  let {
    theme,
    $inline
  } = _ref;
  return css(["", " display:block;font-weight:", ";margin-bottom:0.5rem;color:", ";", ""], getTypography(theme, TypographyName.BODY), FontWeight.BOLD, theme.palettes.neutrals.darkest, $inline && `${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: 13rem;
    display: inline-block;
  }`);
};
export const requiredAsterisk = _ref2 => {
  let {
    theme
  } = _ref2;
  return css(["color:", ";"], theme.palettes.status.alert);
};
//# sourceMappingURL=Label.style.js.map